import { useState } from 'react'
import { getDocuments } from 'document/application/services/documents'
import { getDocumentsMissing } from 'document/domain/utils'
import { logMessageError } from 'shared/infrastructure/exceptions/logError'
import { useAuthProvider } from 'shared/application/hooks/useAuthProvider.hook'
import { ERROR_MESSAGES } from 'domain/enums'

export const useDocumentsRequiredDetails = () => {
  const [documentsRequired, setDocumentsRequired] = useState()
  const [loading, setLoading] = useState(false)
  const auth = useAuthProvider()

  const fetchDocuments = async leadId => {
    try {
      const response = await getDocuments({ proposalId: leadId })
      return response.data.items
    } catch (error) {
      if (error?.response?.status !== 401) {
        logMessageError(
          `${ERROR_MESSAGES.DOCUMENT_LIST} - ID: ${leadId}`,
          JSON.stringify(error?.response),
        )
      }
      if (error?.response?.status === 401) {
        auth.logout()
      }
      return []
    }
  }

  const getDocumentsRequired = async leadId => {
    setLoading(true)
    const documentsRegisteredResponse = await fetchDocuments(leadId)
    setDocumentsRequired(getDocumentsMissing(documentsRegisteredResponse))
    setLoading(false)
  }

  return {
    getDocumentsRequired,
    documentsRequired: {
      items: documentsRequired,
      loading,
    },
  }
}
